module.exports = __webpack_public_path__ + "static/mreavesxlsannarri-020415006EmigreWebOnly-f81602f1807119091e9063b412a28571.woff";